<template>
    <div class="update-button">
      <button class="btn btn-primary" v-show="changed" @click.prevent="updateDb">
        Zapisz zmiany
      </button>
    </div>
</template>

<script>

  export default {
    name: "update_button",
    data: function () {
      return {
      }
    },

    props: [],

    components: {
    },

    computed: {
      ap: {
        get: function() {
          return this.$store.state.auto[this.autoprop];
        },
        set: function(value) {
          this.$store.commit('updateAuto', {obj: this.autoprop, value: value});
        }
      },
      changed: {
        get: function() {
          return this.$store.state.auto['changed'];
        },
        set: function(value) {
          this.$store.commit('updateChanged', value);
        }
      },
    },

    created: function () {
      this.changed = false;
    },

    updated() {
    },

    methods: {
      updateDb: function(){
        let auto = this.$store.state.auto;
        const formData = new FormData();
        for(let p in auto){
          formData.append('historical_auto['+p+']',auto[p]);
        }
        const path = this.$root.updateUrl;
        return this.$http.post(path, formData).then( (response) => {
          this.changed = false;
          this.$store.commit( 'setNotice', {message: "Dane zostały zaktualizowane."} );
        },(error) => {
          console.log(error);
          this.$store.commit('setNotice', {message: error.data});
          // wyłączenie "oczekiwania"
          this.$store.commit('setLoading', false);
        }).then( async (result) => {
          // koniec "oczekiwania"
          this.$store.commit('setLoading', false);
        });
      },

    },

  }
</script>

<style lang="scss" scoped>
    .update-button {
        display: inline-block;
        margin-left: 0.25rem;
    }
</style>